import fetch from 'cross-fetch';
import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client';

import config from '../config';

const httpLink = createHttpLink({
  uri: config.GRAPHQL_SERVER_URL,
  fetch,
  fetchOptions: {
    credentials: 'include',
  },
});

const client = new ApolloClient({
  link: ApolloLink.from([httpLink]),
  cache: new InMemoryCache(),
});

export default client;
